import { useEffect, useState } from "react"

const useSelectSingle = (questionNumber,getData,data,operation) => {

  const [defaultSelectSOptions, setDefaultSelectSOptions] = useState(data?.options||[])
  const [defaultQuestion, setdefaultQuestion] = useState(data?.question || "")
  const [optionText, setOptionText] = useState("")
  const [score, setScore] = useState(0)
  const [description, setDescription] = useState("")
  const [selectSOptions, setSelectSOptions] = useState(data?.options||[])
  const [question, setQuestion] = useState(data?.question||"")
  const onChangeOptionText = (e) => { setOptionText(e.target.value) };
  const onChangeOptionScore = (v) => { setScore(v) };
  const onChangeDescription = (e) => { setDescription(e.target.value) };
  const onChangeQuestion = (e) => { setQuestion(e.target.value) };

  const defaultSelectedOption = (defaultData) => {
    const correctOptions = defaultData?.options?.filter((option) => option.isCorrect) || [];
    return correctOptions.length === 1 ? correctOptions[0].value : "";
  };
  const [defaultSelectedOp, setdefaultSelectedOp] = useState(defaultSelectedOption(data))
  const [selectedOption, setSelectedOption] = useState(operation === "preview"?[]:defaultSelectedOption(data));
  const onChangeSelectedOption = ({ target: { value } }) => {
    setSelectedOption(value);
    let updatedOptions = [...selectSOptions]
    updatedOptions.forEach((option, index) => {
      if (index === value) { updatedOptions[index] = { ...option, isCorrect: true }; }
      else { updatedOptions[index] = { ...option, isCorrect: false } }
    });
    setSelectSOptions(updatedOptions)
  };

  const resetFields = () => { setQuestion(""); setOptionText(""); setScore(0); setDescription(""); setSelectSOptions([]) }
  const resetDefaultFields = () => { setQuestion(defaultQuestion);  setSelectSOptions(defaultSelectSOptions); setSelectedOption(defaultSelectedOp) }


  const addOption = () => {
    if (optionText.length > 0, score > 0, description.length > 0) {
      let selectSOptionsUpdate = [...selectSOptions];
      selectSOptionsUpdate.push({ label: optionText, value: selectSOptions.length, score: score, isCorrect: false, description: description });
      setSelectSOptions(selectSOptionsUpdate);
      setOptionText(""); setScore(0); setDescription("")
    }
  };

  const deleteOption = (optionNumber) => {
    if (optionNumber >= 0) {
      let selectSOptionsUpdate = [...selectSOptions];
      selectSOptionsUpdate.splice(optionNumber, 1);
      setSelectSOptions(selectSOptionsUpdate);
    }
  };

  useEffect(() => {
    getData(questionNumber, { question, options: selectSOptions })
  }, [question, selectSOptions])




  return {
    optionText,
    onChangeOptionText,
    score,
    onChangeOptionScore,
    onChangeDescription,
    onChangeQuestion,
    question,
    selectSOptions,
    deleteOption,
    addOption,
    description,
    resetFields,
    selectedOption,
    onChangeSelectedOption,
    resetDefaultFields

  }
}
export default useSelectSingle